module.exports = __webpack_public_path__ + "img/b4.dd0dd53f.png";